/**
 * Class for rule result Tabs
 */

export enum RuleResultTab {
  HIGHLIGHT = 'Highlight',
  ALL_CONDITIONS = 'All conditions',
  RIDERS = 'Riders',
  GRAPH_VIEW = 'Graph view',
  SMART_RETRY = 'Smart retry',
}

export enum RuleResultTabKeys {
  HIGHLIGHT = 'HIGHLIGHT',
  ALL_CONDITIONS = 'ALL_CONDITIONS',
  RIDERS = 'RIDERS',
  GRAPH_VIEW = 'GRAPH_VIEW',
  SMART_RETRY = 'SMART_RETRY',
}

export enum ResultStatus {
  SMART_RETRY = 'SmartRetry',
  FINAL = 'Final',
}

export type RuleResultTabUnion = `${RuleResultTabKeys}`;

export type RuleResultType = 'Engine' | 'Smart Retry';
